import * as React from 'react';
import WixLogoBlack from '../../assets/logo/wixLogoBlack.svg?url';
import WixLogoWhite from '../../assets/logo/wixLogoWhite.svg?url';
export const WixLogo = ({ skin, ...props }) => {
    const logo = skin === 'dark' ? WixLogoBlack : WixLogoWhite;
    return React.createElement("img", { src: logo, alt: "wix-logo", ...props });
};
//# sourceMappingURL=WixLogo.js.map